class NavTabs {
    constructor() {
        this.navTabs = document.querySelector('[data-nav-tabs]');

        if (this.navTabs) {
            this.navTabItems = this.navTabs.querySelectorAll('[data-nav-tab-item]');
            this.dropdownToggle = this.navTabs.querySelector('[data-tabs-dropdown-toggle]');
            this.dropdown = this.navTabs.querySelector('[data-tabs-dropdown]');
            this.navDropdownItems = this.dropdown.querySelectorAll('[data-nav-dropdown-item]');
        }

        this.listenerIsActive = false;
    }

    init = () => {
        this.dropdownItems = [];
        this.dropdownToggle.classList.remove('is-active');

        if (this.navTabs) {
            const maxOffset = this.navTabs.getBoundingClientRect().width;
            const leftOffset = this.navTabs.getBoundingClientRect().left;

            [...this.navTabItems].forEach((item) => {
                item.classList.add('is-visible');
            });

            [...this.navTabItems].forEach((item, index) => {
                const itemLeftOffset = item.getBoundingClientRect().left - leftOffset;
                if ((itemLeftOffset + item.getBoundingClientRect().width)
                > maxOffset) {
                    this.dropdownItems.push(index);

                    if (item.classList.contains('is-active')) {
                        this.dropdownToggle.classList.add('is-active');
                    }
                }
            });

            [...this.navTabItems].forEach((item, index) => {
                if (this.dropdownItems.indexOf(index) === -1) {
                    item.classList.remove('is-hidden');
                    item.classList.add('is-visible');
                } else {
                    item.classList.remove('is-visible');
                    item.classList.add('is-hidden');
                }
            });

            [...this.navDropdownItems].forEach((item, index) => {
                if (this.dropdownItems.indexOf(index) !== -1) {
                    item.classList.remove('is-hidden');
                    item.classList.add('is-visible');
                } else {
                    item.classList.remove('is-visible');
                    item.classList.add('is-hidden');
                }
            });

            if (this.dropdownItems.length) {
                this.dropdownToggle.classList.add('is-visible');

                if (!this.listenerIsActive) {
                    this.dropdownToggle.addEventListener('click', () => {
                        this.toggle();
                    });

                    this.listenerIsActive = true;
                }
            } else {
                this.dropdownToggle.classList.remove('is-visible');
                this.close();

                this.listenerIsActive = false;
            }
        }
    };

    toggle = () => {
        (this.isOpen ? this.close : this.open)();
    };

    open = () => {
        this.isOpen = true;

        this.dropdown.classList.add('is-open');

        setTimeout(() => {
            window.addEventListener('keydown', this.closeOnEscape);
            window.addEventListener('touchend', this.closeOnClickOutside);
            window.addEventListener('click', this.closeOnClickOutside);
        }, 500);
    };

    close = () => {
        this.isOpen = false;

        this.dropdown.classList.remove('is-open');

        window.removeEventListener('keydown', this.closeOnEscape);
        window.removeEventListener('touchend', this.closeOnClickOutside);
        window.removeEventListener('click', this.closeOnClickOutside);
    };

    closeOnEscape = (event) => {
        if (event.keyCode === 27) {
            this.close();
        }
    };

    closeOnClickOutside = (event) => {
        try {
            if (this.navTabs.contains(event.target) === false) {
                this.close();
            }
        } catch (error) {
            // progressive
        }
    };
}

export default NavTabs;
